import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  items: ItemProps[]
}

export const BannerCTA = memo(function BannerCTA({ items }: Props) {
  if (!items) {
    return null
  }

  return (
    <Container row space="between" tag="section" wrap>
      {items.map((item, index) => (
        <Item key={index} {...item} />
      ))}
    </Container>
  )
})

const Container = styled(FlexBox)``
